import React from 'react';
import { Box } from '@mui/material';
import { ThspianAvatar } from '../../../Avatar/ThspianAvatar';
import { IUserSummary } from '../../../../types/global/helper';
import { BRAND_LUXE_BG } from '../../../../pages/BrandDashboard/brandDashboardTokens';
import { saleStatusVisual } from './brandSalesCardShared';

export interface BrandContestSalesAvatarProps {
    user: IUserSummary | undefined;
    completed: boolean;
    /** Avatar diameter in px. */
    size?: number;
    /** Compact mobile card uses gold gradient ring; desktop row uses plain avatar + dot only. */
    showGradientRing?: boolean;
}

const BrandContestSalesAvatar: React.FC<BrandContestSalesAvatarProps> = ({
    user,
    completed,
    size = 56,
    showGradientRing = true,
}) => {
    const status = saleStatusVisual(completed);
    const badgeSize = size >= 72 ? 22 : size >= 56 ? 18 : 14;
    const ringPad = size >= 72 ? 3 : 2;
    const borderW = size >= 56 ? 3 : 2;

    const avatar = (
        <ThspianAvatar
            user={user}
            disableVerified
            sx={{
                width: size,
                height: size,
                borderRadius: '50%',
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
            }}
        />
    );

    return (
        <Box sx={{ position: 'relative', flexShrink: 0, lineHeight: 0 }}>
            {showGradientRing ? (
                <Box
                    sx={{
                        borderRadius: '50%',
                        p: `${ringPad}px`,
                        background: `linear-gradient(135deg, rgba(255, 201, 101, 0.55) 0%, transparent 65%)`,
                    }}>
                    {avatar}
                </Box>
            ) : (
                avatar
            )}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    width: badgeSize,
                    height: badgeSize,
                    borderRadius: '50%',
                    bgcolor: BRAND_LUXE_BG,
                    border: `${borderW}px solid ${BRAND_LUXE_BG}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1,
                }}>
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        bgcolor: status.dot,
                        boxShadow: `0 0 8px ${status.dot}`,
                    }}
                />
            </Box>
        </Box>
    );
};

export { BrandContestSalesAvatar };
